import {
  CLEAR_FOLLOW_UP_REPORT,
  FOLLOWUP_REPORT_LOADING,
  GET_FOLLOW_UP_REPORT,
  GET_FOLLOW_UP_REPORT_TOTAL,
  GET_FOLLOW_UP_PDF_DATA,
} from './types'

const initState = {
  data: {
    data: [],
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
  totalData: {},
  pdfData: {},
  isLoading: false,
}

export default function (state = initState, action) {
  switch (action.type) {
    case FOLLOWUP_REPORT_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case GET_FOLLOW_UP_REPORT:
      return {
        ...state,
        data: action.payload,
      }
    case GET_FOLLOW_UP_REPORT_TOTAL:
      return {
        ...state,
        totalData: action.payload,
      }
    case CLEAR_FOLLOW_UP_REPORT:
      return initState
    case GET_FOLLOW_UP_PDF_DATA:
      return { ...state, pdfData: action.payload }
    default:
      return { ...state }
  }
}
